export default "__VITE_ASSET__BkSlSqAm__"